module.exports = __webpack_public_path__ + "static/img/logo_03.c13dd4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/logo_03.png
// module id = 32jD
// module chunks = 40